import * as React from 'react';
import clsx from 'clsx';

export interface TabPane {
  header: string;
  content: React.ElementType;
}

interface Props {
  panes: TabPane[];
}

export const Tabs = ({ panes }: Props) => {
  const [activeIndex, setActiveIndex] = React.useState(0);

  return (
    <div className="c-tab">
      <ul className="c-tab__header">
        {panes.map((pane, idx) => {
          return (
            <li
              key={pane.header}
              className={clsx({ 'c-tab__header__item': true, 'is-active': idx === activeIndex })}
              onClick={() => setActiveIndex(idx)}
            >
              <h3 className="c-tab__header__item__text">{pane.header}</h3>
            </li>
          );
        })}
      </ul>
      {panes.map((pane, idx) => {
        const Content = pane.content;
        const className = idx === activeIndex ? 'c-tab__body__item is-active' : 'c-tab__body__item';
        return (
          <ul key={pane.header} className="c-tab__body">
            <li className={className}>
              <Content />
            </li>
          </ul>
        );
      })}
    </div>
  );
};
